import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from '../themes/ThemeProvider';
const baseStyle = {
    width: 27,
    height: 24,
    marginLeft: 12,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
};
const circleBase = {
    width: 15,
    height: 15,
    borderRadius: '50%',
    border: '2px solid #bbb',
    background: '#fff',
    display: 'inline-block',
    marginRight: 8,
    position: 'relative',
    transition: 'border 0.2s, background 0.2s',
};
const Radio = ({ checked, value, onChange, disabled = false, 'data-testid': dataTestId, className, variant = 'primary', style, ...rest }) => {
    const theme = useTheme();
    const primaryColor = theme.radioPrimaryColor ?? 'var(--interactive-primary-default, #D64000)';
    const dangerColor = theme.radioDangerColor ?? '#DC0A0A';
    const variants = {
        default: {},
        primary: {
            border: `6px solid ${primaryColor}`,
            width: 7,
            height: 7,
        },
        danger: {
            border: `6px solid ${dangerColor}`,
            background: dangerColor,
            width: 7,
            height: 7,
        },
    };
    const circleStyle = checked ? { ...circleBase, ...variants[variant] } : circleBase;
    return (_jsxs("label", { style: {
            ...baseStyle,
            cursor: disabled ? 'not-allowed' : 'pointer',
            ...(style || {}),
        }, className: className, children: [_jsx("input", { type: 'radio', checked: checked, value: value, onChange: onChange, disabled: disabled, "data-testid": dataTestId, style: { display: 'none' }, ...rest }), _jsx("span", { "aria-hidden": 'true', style: circleStyle })] }));
};
export default Radio;
